"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Metaform REST API
 * REST API for Metaform
 *
 * The version of the OpenAPI document: 2.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
function ExportThemeFromJSON(json) {
    return ExportThemeFromJSONTyped(json, false);
}
exports.ExportThemeFromJSON = ExportThemeFromJSON;
function ExportThemeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !runtime_1.exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        'parentId': !runtime_1.exists(json, 'parentId') ? undefined : json['parentId'],
        'locales': !runtime_1.exists(json, 'locales') ? undefined : json['locales'],
    };
}
exports.ExportThemeFromJSONTyped = ExportThemeFromJSONTyped;
function ExportThemeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'parentId': value.parentId,
        'locales': value.locales,
    };
}
exports.ExportThemeToJSON = ExportThemeToJSON;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRXhwb3J0VGhlbWUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvZ2VuZXJhdGVkL2NsaWVudC9tb2RlbHMvRXhwb3J0VGhlbWUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLG9CQUFvQjtBQUNwQixvQkFBb0I7QUFDcEI7Ozs7Ozs7Ozs7R0FVRzs7QUFFSCx3Q0FBK0M7QUFpQy9DLFNBQWdCLG1CQUFtQixDQUFDLElBQVM7SUFDekMsT0FBTyx3QkFBd0IsQ0FBQyxJQUFJLEVBQUUsS0FBSyxDQUFDLENBQUM7QUFDakQsQ0FBQztBQUZELGtEQUVDO0FBRUQsU0FBZ0Isd0JBQXdCLENBQUMsSUFBUyxFQUFFLG1CQUE0QjtJQUM1RSxJQUFJLENBQUMsSUFBSSxLQUFLLFNBQVMsQ0FBQyxJQUFJLENBQUMsSUFBSSxLQUFLLElBQUksQ0FBQyxFQUFFO1FBQ3pDLE9BQU8sSUFBSSxDQUFDO0tBQ2Y7SUFDRCxPQUFPO1FBRUgsSUFBSSxFQUFFLENBQUMsZ0JBQU0sQ0FBQyxJQUFJLEVBQUUsSUFBSSxDQUFDLENBQUMsQ0FBQyxDQUFDLFNBQVMsQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQztRQUNsRCxNQUFNLEVBQUUsSUFBSSxDQUFDLE1BQU0sQ0FBQztRQUNwQixVQUFVLEVBQUUsQ0FBQyxnQkFBTSxDQUFDLElBQUksRUFBRSxVQUFVLENBQUMsQ0FBQyxDQUFDLENBQUMsU0FBUyxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsVUFBVSxDQUFDO1FBQ3BFLFNBQVMsRUFBRSxDQUFDLGdCQUFNLENBQUMsSUFBSSxFQUFFLFNBQVMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxTQUFTLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUM7S0FDcEUsQ0FBQztBQUNOLENBQUM7QUFYRCw0REFXQztBQUVELFNBQWdCLGlCQUFpQixDQUFDLEtBQTBCO0lBQ3hELElBQUksS0FBSyxLQUFLLFNBQVMsRUFBRTtRQUNyQixPQUFPLFNBQVMsQ0FBQztLQUNwQjtJQUNELElBQUksS0FBSyxLQUFLLElBQUksRUFBRTtRQUNoQixPQUFPLElBQUksQ0FBQztLQUNmO0lBQ0QsT0FBTztRQUVILElBQUksRUFBRSxLQUFLLENBQUMsRUFBRTtRQUNkLE1BQU0sRUFBRSxLQUFLLENBQUMsSUFBSTtRQUNsQixVQUFVLEVBQUUsS0FBSyxDQUFDLFFBQVE7UUFDMUIsU0FBUyxFQUFFLEtBQUssQ0FBQyxPQUFPO0tBQzNCLENBQUM7QUFDTixDQUFDO0FBZEQsOENBY0MifQ==